import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { ReportAuthProvider } from './context/ReportAuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Home            from './pages/Home';
import ReportTypes     from './pages/ReportTypes';
import Checkout        from './pages/Checkout';
import Processing      from './pages/Processing';
import Report          from './pages/Report';
import Help            from './pages/Help';
import Contact         from './pages/Contact';
import PrivacyPolicy   from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51Oe7xRFlJQ9qioSs6rief539WY829vcm0W24lnKiettyueuENiQQvEMi8LwY3QxFO1fAIdkdELRhegIR7LVZGBy600UPsHuYKh');

const stripeOptions = {
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary:       '#0066cc',
      colorBackground:    '#ffffff',
      colorText:          '#1a1a1a',
      colorDanger:        '#dc3545',
      fontFamily:         'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      spacingUnit:        '4px',
      borderRadius:       '8px',
    },
  },
};

export default function App() {
  return (
    <BrowserRouter>
      <ReportAuthProvider>
        <Elements stripe={stripePromise} options={stripeOptions}>
          <Routes>
            <Route path="/"                  element={<Home />} />
            <Route path="/report-types"      element={<ReportTypes />} />
            <Route path="/checkout"          element={<Checkout />} />
            <Route path="/processing"        element={<Processing />} />
            <Route path="/help"              element={<Help />} />
            <Route path="/contact"           element={<Contact />} />
            <Route path="/privacy-policy"    element={<PrivacyPolicy />} />
            <Route path="/terms-conditions"  element={<TermsConditions />} />

            {/* Protected — requires valid report JWT */}
            <Route
              path="/report"
              element={
                <ProtectedRoute>
                  <Report />
                </ProtectedRoute>
              }
            />

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Elements>
      </ReportAuthProvider>
    </BrowserRouter>
  );
}
